import * as React from 'react';
// Utils
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
// Constants
import { IRootState } from '@src/store';
// Actions, Models & Interfaces
import { PassengerModel } from '@src/shared/src/models';
// Components
// Styles
import '../styles/CheckoutSummary.scss';

type Props = {
  passengers: PassengerModel[];
  bookedBy: string;
};

const CheckoutSummary: React.FC<Props> = ({ passengers, bookedBy }) => {
  const { t } = useTranslation();
  const booking = useSelector((state: IRootState) => state.checkout.currentBooking);
  return (
    <div className="checkout-summary">
      <div className="checkout-summary-item">
        <i className="material-symbols">numbers</i>
        <div>
          {t('checkoutSummary.label.bookingId')}
          <b>{booking?.id}</b>
        </div>
      </div>
      <div className="checkout-summary-item">
        <i className="material-symbols">account_circle</i>
        <div>
          {t('checkoutSummary.label.bookedBy')}
          <b>{bookedBy}</b>
        </div>
      </div>
      <div className="checkout-summary-item">
        <i className="material-symbols">group</i>
        <div>
          {t('checkoutSummary.label.passengers')}
          <b>{passengers.map((passenger) => `${passenger.firstName} ${passenger.lastName}`).join(', ')}</b>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSummary;
